import { useQuery } from "@tanstack/react-query";
import uniqBy from "lodash/uniqBy";
import { getLastApprovedVcm, getPointRequest, getUser } from "../api/user";

import { atom, useAtom } from 'jotai';

const userDefault = atom({});

export const useUser = () => {
  const [user, setUser] = useAtom(userDefault);

  const UpdateUser = (newUser) => {
    setUser(newUser);
  };

  return {
    user,
    UpdateUser
  };
};

export const useUserQuery = (userId) => {
  return useQuery({
    queryKey: ["user", userId],
    queryFn: () => getUser(userId),
    enabled: !!userId, // Only run the query if userId is valid
  });
};

export const usePointRequestQuery = ({userId, id}) => {
  return useQuery({
    queryKey: ["pointRequest", id],
    queryFn: () => getPointRequest(userId, id),
    enabled: !!id, // Only run the query if id is valid
  });
};

export const useLastApprovedVcmQuery = (userId) => {
  return useQuery({
    queryKey: ["lastApprovedVcm", userId],
    queryFn: () => getLastApprovedVcm(userId),
    enabled: !!userId, // Only run the query if userId is valid
  });
};

export const generateVcmUnits = (lastApprovedVcmData) => {
  if (!lastApprovedVcmData) {
    return [];
  }
  return uniqBy(
    lastApprovedVcmData.courses
      .flatMap((course) => course.units)
      .concat(lastApprovedVcmData.units),
    "code",
  );
};
